import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.salesrep/territory-manager/division/division-edit.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import resolve from "ioc/resolve";
import modals from 'webmodals/modals'
import VendorPicker from 'emun.vendor/picker/vendor-picker'
import TerritoryPicker from 'emun.salesrep/territory-manager/territory/picker/territory-picker'
import ServiceBus from "servicestack/service-bus";

class DivisionEditController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
	}
	$onInit() {
		const $ctrl = this;
		const id = $ctrl.divisionId;
		$ctrl.bus = new ServiceBus();
		if (id == "create") {
			$ctrl.division = { id: "create" };
		} else {
			let options = {
				url: "QueryDivisions.json?Id=" + id,
				autoLoad: true,
				append: false,
				pageSize: 24,
				onLoaded: args => {
					$ctrl.division = args.first;
				}
			};
			$ctrl.query = new AutoQuery(options);
		}
		$ctrl.vendors = new AutoQuery({
			url: "QueryVendors.json",
			criteria: {
				DivisionId: id
			},
			orderBy: "Label",
			autoLoad: true
		});
		$ctrl.territories = new AutoQuery({
			url: "QueryTerritories.json",
			criteria: {
				DivisionId: id
			},
			autoLoad: true
		});
	}
	submit(close) {
		const $ctrl = this;
		const action = `${$ctrl.division.id == "create" ? "Cre" : "Upd"
			}ateDivision.json`;

		return $ctrl.bus.send(action, $ctrl.division).then((res) => {
			$ctrl.division.id = res.data.id;
			$ctrl.territories.criteria.DivisionId = $ctrl.division.id;
			$ctrl.vendors.criteria.DivisionId = $ctrl.division.id;
			if (close) resolve("$state").go("divisions");
		});
	}

	addVendor() {
		let $ctrl = this;
		$ctrl.vendorIds = [];

		return VendorPicker({
			title: "Select Vendor(s)...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false, 
		}).then((result) => {
			$ctrl.bus.send("AddDivisionVendors", {
				DivisionId: $ctrl.division.id,
				VendorIds: result
			}).then(function (response) {
				$ctrl.vendors.load();
			});
		});
	}

	addTerritory() {
		let $ctrl = this;
		$ctrl.territoryIds = [];

		return TerritoryPicker({
			title: "Select Territories...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false, 
		}).then((result) => {
			$ctrl.bus.send("AddDivisionTerritories", {
				DivisionId: $ctrl.division.id,
				TerritoryIds: result
			}).then(function (response) {
				$ctrl.territories.load();
			});
		});
	}

	deleteVendor(vendor) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + vendor.label, "Remove Vendor?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteDivisionVendor.json", {
						DivisionId: $ctrl.division.id,
						VendorId: vendor.id
					})
					.then(function () {
						return $ctrl.vendors.load(true);
					})
					.catch(

					);
			});
	}

	deleteTerritory(territory) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + territory.name, "Remove Territory?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteTerritoryDivision.json", {
						DivisionId: $ctrl.division.id,
						TerritoryId: territory.id
					})
					.then(function () {
						return $ctrl.territories.load(true);
					})
					.catch(

					);
			});
	}

}

let DivisionEdit = {
	controller: DivisionEditController,
	bindings: {
		divisionId: "@"
	},
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default DivisionEdit;
